<template>
  <div class="relative">
    <button ref="currencybutton" @click="toggleMenu" class="currency-button flex items-center justify-center w-12.5 lg:w-15 h-12.5 lg:h-15 px-5 shadow-left text-base uppercase font-primary tracking-1/4 text-white">
      <span class="mr-0.5">{{ currentCurrency }}</span><span class="triangle triangle-sm ml-0.5"></span>
    </button>
    <div ref="currencymenu" class="currency-select__menu bg-blue-dark absolute">
      <button @click="updateCurrency('GBP')" class="flex items-center justify-center w-12.5 lg:w-15 h-12.5 lg:h-15 px-5 uppercase font-primary tracking-1/4 text-white hover:bg-yellow-brand hover:text-blue-dark">
        <span class="text-18">£</span>
      </button>
      <button @click="updateCurrency('USD')" class="flex items-center justify-center w-12.5 lg:w-15 h-12.5 lg:h-15 px-5 uppercase font-primary tracking-1/4 text-white hover:bg-yellow-brand hover:text-blue-dark">
        <span class="text-18">$</span>
      </button>
    </div>
  </div>
</template>

<script>
import { collapseSection, expandSection } from '../src/Helpers';

export default {
  created() {
    this.$store.dispatch('currency/GET_CURRENCY');
  },

  computed: {
    currentCurrency() {
      if (this.$store.state.currency.currentCurrency === 'GBP') {
        return '£';
      }
      else if (this.$store.state.currency.currentCurrency === 'USD') {
        return '$';
      }
    },
  },

  methods: {
    toggleMenu() {
      let expandButton = this.$refs.currencybutton;
      let menu = this.$refs.currencymenu;

      if (!expandButton.classList.contains('is-active')) {
        expandSection(menu);
        expandButton.classList.add('is-active');
      } else if (expandButton.classList.contains('is-active')) {
        collapseSection(menu);
        expandButton.classList.remove('is-active');
      }
    },

    updateCurrency(currency) {
      this.toggleMenu();
      this.$store.dispatch('currency/SET_CURRENCY', currency);
    },
  },
}
</script>
